import api from './api';

export const getPayments = (page, params) => {
  return api.get('admin/Transaction', { params: { page: page, limit: 10, ...params } });
};
export const getTransactionDetails = uid => {
  return api.get(`admin/transaction/${uid}`);
};

export const refundTransaction = uid => {
  return api.post(`admin/transaction/${uid}/refund`);
};

export const getWithdrawRequests = page => {
  return api.get(`admin/withdraw/requests`, { params: { page: page }});
};

export const updateTransactionStatus = (uid, status) => {
  return api.put(`admin/transaction/${uid}/status`, { status: status });
}

export const setTransactionId = (uid, transactionIdInOrigin) => {
  return api.put(`admin/transaction/${uid}/transactionIdInOrigin/${transactionIdInOrigin}`);
};

export const getRecipients = (page, params) => {
  return api.get('admin/Recipient', { params: { page: page, limit: 10, ...params } });
};

export const getDuplicatedTransactions = page => {
  return api.get(`admin/transactions/duplicated`, { page: page });
}

export const getListOfDuplicated = (transactionIdInOrigin, paymentToken) => {
  return api.get(`admin/transactions/duplicated/${transactionIdInOrigin}/${paymentToken}/info`);
}

export const updateTransactionConfirmedStatus = (uid, confirmed) => {
  return api.put(`admin/transaction/${uid}/confirmed`, { confirmed });
}

export const updateTransactionWaitingForPayment = (uid, isWaitingForPayment) => {
  return api.put(`admin/transaction/${uid}/waitingForPayment`, { isWaitingForPayment });
}

export const sendNFe = (recipientId, transactionId) => {
  return api.post(`admin/recipient/${recipientId}/transaction/${transactionId}/send_nfe`);
};